import {
  initialState,
  Actions,
  State,
  EDIT_CALENDAR,
  EDIT_CALENDAR_SUCCESS,
  EDIT_CALENDAR_ERROR,
  RESET_EDIT_CALENDAR,
} from "../../types/calendar/edit";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case EDIT_CALENDAR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case EDIT_CALENDAR_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case EDIT_CALENDAR_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      };
    case RESET_EDIT_CALENDAR:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducers;
